<template>
	<svg
		width="28"
		height="30"
		viewBox="0 0 28 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M25.6667 0H5.66667C4.34059 0 3.06882 0.526784 2.13114 1.46447C1.19346 2.40215 0.666672 3.67392 0.666672 5V25C0.666672 26.3261 1.19346 27.5979 2.13114 28.5355C3.06882 29.4732 4.34059 30 5.66667 30H25.6667C26.1087 30 26.5326 29.8244 26.8452 29.5118C27.1577 29.1993 27.3333 28.7754 27.3333 28.3333V1.66667C27.3333 1.22464 27.1577 0.800716 26.8452 0.488155C26.5326 0.175595 26.1087 0 25.6667 0ZM5.66667 3.33333H24V20H5.66667C5.0981 20.0045 4.53446 20.106 4 20.3V5C4 4.55797 4.1756 4.13405 4.48816 3.82149C4.80072 3.50893 5.22464 3.33333 5.66667 3.33333ZM5.66667 26.6667C5.22464 26.6667 4.80072 26.4911 4.48816 26.1785C4.1756 25.866 4 25.442 4 25C4 24.558 4.1756 24.134 4.48816 23.8215C4.80072 23.5089 5.22464 23.3333 5.66667 23.3333H24V26.6667H5.66667Z"
			fill="black"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconLearning',
}
</script>
